import { newPageInfo, newRouteParamsType } from "@hex-insights/router";
import { Student, StudentFormat, StudentNameFragment } from "@hex-insights/verita-romania.shared";
import { reEnrollmentStudentHealthPageInfo } from "../pageinfo";

type StudentForRouteTitle = StudentNameFragment;

export const reEnrollmentStudentHealthDetailPageInfo = newPageInfo({
	name: "Re-Enrollment Student Health Detail",
	title: (instance: StudentForRouteTitle) => StudentFormat.name(instance),
	description: reEnrollmentStudentHealthPageInfo.description,
	exact: true,
	noSearch: true,
	to: (id: Student["id"]) => reEnrollmentStudentHealthPageInfo.to + `/${id}`,
	path: reEnrollmentStudentHealthPageInfo.path + "/:studentID(\\d+)",
	parent: reEnrollmentStudentHealthPageInfo,
	paramsType: newRouteParamsType(reEnrollmentStudentHealthPageInfo.paramsType, "studentID"),
});
